import { createSlice } from "@reduxjs/toolkit";

export const selectedPatientSlice = createSlice({
  name: "selectedPatient",
  initialState: {
    value: undefined,
  },
  reducers: {
    updateSelectedPatient: (state, action) => {
      state.value = action.payload;
    },
    clearSelectedPatient: (state) => {
      state.value = undefined;
      sessionStorage.removeItem("patientId");
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateSelectedPatient, clearSelectedPatient } =
  selectedPatientSlice.actions;

export default selectedPatientSlice.reducer;
